/* eslint-disable react/jsx-props-no-spreading */
import { Provider } from 'react-redux';
import { InferGetServerSidePropsType } from 'next';
import { makeStore } from '@doda/pc/src/redux/store';
import { getServerSideProps } from './getServerSideProps';
import { JobSearchDetail } from './screens/JobSearchDetailScreen';

export { getServerSideProps };

/**
 *
 */
export default function Index(
  props: InferGetServerSidePropsType<typeof getServerSideProps>
) {
  const { initialState, ...pageProps } = props;
  // 410ステータスの場合の対応 - 不要なレンダリングをスキップ
  if (!pageProps.job) return null;

  const store = makeStore({ preloadedState: initialState });

  return (
    <Provider store={store}>
      <JobSearchDetail {...pageProps} />
    </Provider>
  );
}
